import {FetchHandler} from "../../infrastructure/handlers/fetch-handler";
import {EntitiesRecognizerDomainService} from "../../domain/entities-recognizer/services/entities-recognizer.domain-service";
import {EntitiesRecognizerRequestParams} from "../../domain/entities-recognizer/models/entities-recognizer.request-params";
import {EntitiesRecognizerDataSource} from "../../domain/entities-recognizer/models/entities-recognizer.data-source";
import {AppModuleState} from "../app/models/app-module.state";
import {APP} from "../app/consts";
import {BaseDomainParams} from "../../infrastructure/models/params/base-domain-params";

export class EntitiesRecognizerFetchHandler extends FetchHandler {
  state: AppModuleState;
  type = APP.ACTION_TYPES.fetchEntitiesRecognizer;

  static injectables = [EntitiesRecognizerDomainService];

  get requestParams(): EntitiesRecognizerRequestParams {
    const requestParams: EntitiesRecognizerRequestParams = new EntitiesRecognizerRequestParams(this.state.settings.bootstrapSettings.paramsResource, this.state.settings.bootstrapSettings.entitiesRecognizerUrl || window.location.href);

    return requestParams;
  }

  createDomainParams(fetchParams: Object = {}, url: String): BaseDomainParams {
    const params: BaseDomainParams = new BaseDomainParams(this.requestParams, fetchParams, this.controller.config.name);

    return params;
  }

  async action(params) {
    let dataSource: EntitiesRecognizerDataSource = null;

    if (this.state.settings.isContextualMode || this.state.settings.isUrlMode) {
      dataSource = await super.fetch();

      this.state.entitiesRecognizerDataSource = dataSource;
    }

    return dataSource;
  }
}
